import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-category-coupon-slider-3',
  templateUrl: './category-coupon-slider-3.component.html',
  styleUrls: ['./category-coupon-slider-3.component.css']
})

export class CategoryCouponSlider3Component implements OnInit {
  @Input() coupon: any;
  @Input() category: any;
  @Input() typeCode: number;

  @Output() couponSettingsChanged = new EventEmitter<any>();

  changeCategorySettings() {
    if (this.category.soglia[0] > this.category.soglia_max) {
      this.category.soglia[0] = this.category.soglia_max;
      this.category.soglia[1] = this.category.soglia_max;
    } else if (this.category.soglia[1] > this.category.soglia_max) {
      this.category.soglia[1] = this.category.soglia_max;
    }
    this.category.soglia = [this.category.soglia[0], this.category.soglia[1]];
  }

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/category-coupons-slider/category-coupon-slider-3/category-coupon-slider-3.component.ts